// components/Footer.js
import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <footer>
            <div className="container">
                <p>&copy; 2024 Weapon Recognition System. All rights reserved.</p>
            </div>
        </footer>
    );
}

export default Footer;

